import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as typography from "@styles/typography.module.css";
import GoogleSafeBrowsing from "@svgs/googleSafeBrowsing.svg";
import * as styles from "./safeWebsiteSection.module.css";
const SafeWebsiteSection = () => {
    return (_jsxs("div", { className: styles.safeWebsiteSection, children: [_jsx("p", { className: typography.subHeader2, children: "Site Seguro" }), _jsx(GoogleSafeBrowsing, {})] }));
};
export default SafeWebsiteSection;
